import { UserIcon } from '@heroicons/react/solid'
import { propOr } from 'ramda'

import Link from '@/components/link'
import useProfile from '@/modules/user/stores/use-profile'

const profileSelector = propOr({}, 'profile')

const User = () => {
  const { name = '', avatar, avatarName = '' } = useProfile(profileSelector)

  return (
    <div className='flex w-full max-w-[90%] items-start justify-between pt-4'>
      <div className='flex flex-col justify-center '>
        <p className='pt-3 text-2xl text-gray-900 sm:text-[30px] sm:text-2xl'>
          Welcome {avatarName.length > 0 ? avatarName : name.split(' ')[0]}!
        </p>
      </div>
      <Link href='/dashboard/profile'>
        <div className='flex-shrink-0'>
          {avatar ? (
            <img
              className='mx-auto h-20 w-20 rounded-full bg-white sm:h-36 sm:w-36'
              src={avatar}
              alt=''
            />
          ) : (
            <UserIcon className='mx-auto h-20 w-20 rounded-full border-2 bg-theme-green p-4 text-gray-50' />
          )}
        </div>
      </Link>
    </div>
  )
}

export default User
